<template>
    <div style="position:relative">
        <div :style="spinShow?'height:100vh':''">
            <ul class="product clearfix" v-if="maintenanceRateList.length">
                <li class="content">
                    <left-image v-if="productImage.detailImageList" :imageList="productImage.detailImageList"/>
                </li>
                <li class="content contentText">
                    <h2>{{product.productName}}&nbsp;({{product.productDesc}})</h2>
                    <ul class="price">
                        <li class="priceItem">
                            <span style="color:#828080;font-size:16px">价格</span>
                            <span style="color:#ff9000;padding-left:10px">
                                ¥
                                <strong style="font-size:25px">{{product.benchmarkPrice}}</strong>
                            </span>
                        </li>
                        <li class="priceItem brandNew">
                            <p>全新</p>
                        </li>
                        <li class="priceItem" style="margin-left:0">
                            <span style="color:#828080;font-size:16px;">起购数：</span>
                            <strong style="color:#ff9000;font-size:23px;padding-left:10px ">{{product.minPurchaseQty}}</strong>
                        </li>
                    </ul>
                    <div class="dailyRental">
                        <table class="tableStyle" width="98%" border="1" cellpadding="0" cellspacing='0'>
                            <tr>
                                <td>拆借日租金</td>
                                <td>共享日收益</td>
                                <td>残值回购率</td>
                            </tr>
                            <tr>
                                <td>{{product.dailyRental}}元/天</td>
                                <td>{{product.dailyYield}}元/天</td>
                                <td>{{product.recoveryRate}}%</td>
                            </tr>
                        </table>
                    </div>
                    <div class="dailyRental" v-if="maintenanceRateList.length">
                        <table class="tableStyle" width="98%" border="1" cellpadding="0" cellspacing='0'>
                            <tr>
                                <td :rowspan="maintenanceRateList.length">维护费率</td>
                                <td v-for="item in maintenanceRateList" :key="item.startYear">{{item.startYear}}年-{{item.endYear}}年</td>
                            </tr>
                            <tr>
                                <td v-for="item in maintenanceRateList" :key="item.startYear">{{item.maintenanceRate}}%</td>
                            </tr>
                        </table>
                    </div>
                    <ul class="specifications">
                        <li class="specifica">
                            <p>尺寸</p>
                            <div class="text">{{product.length}}mm*{{product.width}}mm*{{product.height}}mm</div>
                        </li>
                        <li class="specifica" style="margin-left:50px">
                            <p>重量</p>
                            <div class="text" style="margin-left:25px">{{product.weight}}kg</div>
                        </li>
                    </ul>

                    <ul class="specifications">
                        <li class="specifica deadLoad">
                            <p style="margin-right:20px">额定载荷</p>
                            <ul class="dynamicLoad">
                                <li>静载 {{product.deadLoad}}kg</li>
                                <li>动载 {{product.dynamicLoad}}kg</li>
                                <li v-if="product.shelfLoad">货架 {{product.shelfLoad}}kg</li>
                            </ul>

                        </li>
                    </ul>
                    <ul class="specifications" v-if="product.processTech">
                        <li class="specifica">
                            <p>工艺</p>
                            <div class="text">{{$options.filters['queryDict']('target', 'processTech', product.processTech)}}&nbsp;|&nbsp;{{$options.filters['queryDict']('target', 'moldTech', product.moldTech)}}</div>
                        </li>
                    </ul>
                    <ul class="specifications">
                        <li class="quantity">
                            <p>数量</p>
                            <div class="quantityInput">
                                <ul>
                                    <li>
                                        <input type="number" v-model="order.quantity" min="1" :max="maxVal" @blur="order.quantity = Math.max(order.quantity, product.minPurchaseQty)">
                                    </li>
                                    <li>
                                        <p class="top" @click="onPush">
                                            <Icon class="iconfont" type="ios-arrow-up" />
                                        </p>
                                        <p class="bottom" @click="onMinus" v-if="order.quantity > 1">
                                            <Icon class="iconfont" type="ios-arrow-down" />
                                        </p>
                                        <p class="bottom disable" v-else>
                                            <Icon class="iconfont" type="ios-arrow-down" />
                                        </p>
                                    </li>
                                </ul>
                            </div>
                        </li>
                    </ul>
                    <div class="deliveryOptions clearfix">
                        <div class="options">
                            <p>配送回收</p>
                            <div>
                                <div>
                                    <radio :options="deliveryOptions" @on-change="val => order.deliveryMethod = val" />
                                </div>
                                <p>
                                    <span v-if="order.deliveryMethod == 'Y' ">注:运费全国统一{{product.shippingFee}}元/片(配送数量500片以上)</span>

                                </p>
                            </div>

                        </div>
                    </div>
                    <ul class="specifications">
                        <li class="specifica">
                            <p>地址</p>
                            <div class="text addrCascader">
                                <addr-cascader style="width:200px" v-model="areaId" />
                            </div>
                        </li>
                    </ul>
                    <!-- <ul class="textInput" >
                    <li class="addrad">
                        <p>详细地址</p>
                        <div><input type="text"/></div>
                    </li>
                </ul> -->
                    <ul class="specifications">
                        <li class="specifica">
                            <p>合计费用</p>
                            <div class="text totalFee">￥{{totalFee}}</div>
                        </li>
                    </ul>
                    <div >
                        <Button type="warning" size="large" @click="onBuyNow" style="width: 120px; margin: 27px">立即购买</Button>
                    </div>
                </li>
            </ul>

            <!-- tab -->
            <div class="descImage">
                <tabs :tabList="tabList" id="tabs" @onActive="onActive" :tabsTop="1081" width="1080px"></tabs>
                <div class="detail">
                    <div v-show="tabShow === 'imgDesc'">
                        <img-desc :descImageList="productImage.descImageList" />
                    </div>
                    <div v-show="tabShow === 'businessFlow'">
                        <business-flow />
                    </div>

                </div>

            </div>
        </div>
        <qrcode-product :qrCode="productImage.qrCode"/>
        <buy-now ref="buyNowRef" />
        <my-spin :spinShow="spinShow" />
    </div>
</template>

<script>
import leftImage from '@/views/mall/product-details/left-image.vue';
import radio from 'components/radio.vue';
import addrCascader from 'components/select/addr-cascader.vue';
import tabs from '@/views/mall/product-details/component/tabs.vue'
import imgDesc from './componet/imgDesc.vue';
import businessFlow from './componet/businessFlow.vue'
import mySpin from '_c/app-component/mySpin.vue'//加载loading

import buyNow from './componet/buyNow.vue'
import qrcodeProduct from '_c/app-component/qrcode-product'//商品二维码

export default {
    name:'palletBankDetail',
    components: { leftImage, radio, addrCascader, tabs, imgDesc, businessFlow, buyNow,mySpin,qrcodeProduct},
    data() {
        return {
            spinShow: true,
            maxVal: 99999,
            tabShow: 'imgDesc',
            product: {},
            productImage: {},
            maintenanceRateList: [],
            tabList: [
                { title: '产品详情', desc: 'imgDesc' },
                { title: '业务流程', desc: 'businessFlow' },
            ],
            deliveryOptions: [
                { text: '配送上门', value: 'Y' },
                { text: '货物自提', value: 'N' },
            ],
            order: {
                deliveryMethod: '',
                quantity: 100,
            },
            areaId: '',
        }
    },
    computed: {
        totalFee: function () {
            let { shippingFee, benchmarkPrice } = this.product;
            let unitPrice = +benchmarkPrice;

            if (this.order.deliveryMethod == 'Y')
                unitPrice += +shippingFee;

            return unitPrice * (this.order.quantity || 0);
        }
    },
    async beforeCreate() {
        await this.dict.initDict([
            { id: 'processTech', namespace: 'target' },
            { id: 'moldTech', namespace: 'target' },
        ]);
    },
    mounted() {
        this.product.productId = this.$route.query.productId;
        this.queryPalletBankProductByProductId();
        this.queryProductImage();
        this.queryProductMaintenanceRate();
    },
    methods: {
        async onBuyNow() {
            if (this.order.quantity < this.product.minPurchaseQty) {
                return this.$Message.warning(`起购数量${this.product.minPurchaseQty}`)
            }

            let sessionId = this.pltSession.getSession()
            if (!sessionId) {
                await this.showConfirm('提示', '您还未登录, 去登录?')
                this.$router.push('/login');
                this.$store.commit('anonymous/setPath', { query: { productId: this.product.productId }, to: '/pallet-bank-details' });
                return;
            }
            let data = {
                productId:this.product.productId,
                quantity: this.order.quantity,
                areaId: this.areaId,
                deliveryMethod: this.order.deliveryMethod,
                minPurchaseQty:this.product.minPurchaseQty
            }
            this.$refs['buyNowRef'].openModal(data)
        },
        onActive(params) {
            this.tabShow = params
        },
        onPush() {
            if (this.order.quantity > this.maxVal) {
                this.order.quantity = this.maxVal

            } else {
                this.order.quantity++
            }
        },
        onMinus() {
            this.order.quantity--
        },
        async queryPalletBankProductByProductId() {
            let param = {
                url: "http://MID-CLIENT-MALL/messageService/productService/queryProductConfigByProductId",
                body: { productId: this.product.productId }
            }
            await this.invoke(param).then(rs => {
                this.product = rs;
            })

            let targetCode = this.product.targetModelCode;

            let param2 = {
                url: 'http://CORE-TARGET/messageService/baseInfoService/queryTargetConfigurationByTargetCode',
                body: { targetCode }
            };
            this.invoke(param2).then(model => {
                this.product = { ...this.product, ...model }
            })

        },


        queryProductImage() {
            let param = {
                url: "http://MID-CLIENT-MALL/messageService/productService/queryProductImage",
                body: { productId: this.product.productId }
            }
            this.invoke(param).then(rs => {
                this.productImage = rs;
            })
        },
        queryProductMaintenanceRate() {
            let param = {
                url: "http://MID-CLIENT-MALL/messageService/productService/queryProductMaintenanceRateByProductId",
                body: { productId: this.product.productId }
            }
            this.invoke(param).then(rs => {
                this.maintenanceRateList = rs;
                this.spinShow = false;

            })

        }
    }
}
</script>
<style lang="scss" scoped>
.product {
    margin-top: 20px;
    .content {
        float: left;
    }
    .contentText {
        width: 625px;
        margin-left: 20px;
        .price {
            width: 625px;
            height: 45px;
            background: #ecebeb;
            margin: 20px 0;
            line-height: 45px;
            .priceItem {
                float: left;
                margin-left: 30px;
            }
            .brandNew {
                margin: 10px 30px;
                p {
                    color: #fff;
                    font-size: 16px;
                    // padding-left:30px;
                    text-align: center;
                    border-radius: 5px;
                    width: 60px;
                    height: 25px;
                    background: #ff8800;
                    line-height: 25px;
                }
            }
        }
        .dailyRental {
            margin: 30px 0 0 30px;
            .tableStyle {
                border: 1px solid #c4c1c1;

                tr {
                    border: 1px solid #c4c1c1;
                    text-align: center;

                    td {
                        width: 177px;
                        height: 48px;
                        border: 1px solid #c4c1c1;
                    }
                }
            }
        }
        .specifications {
            width: 582px;
            margin: 30px 0 0 30px;
            display: flex;
            // flex-direction: row;
            // justify-content: space-between;
            .specifica {
                // height: 37px;
                line-height: 37px;
                p,
                div {
                    float: left;
                }
                .text {
                    height: 35px;
                    line-height: 35px;
                    padding: 0 10px;
                    border: 2px solid #c4c1c1;
                    margin-left: 47px;
                }
            }
            .deadLoad {
                .dynamicLoad {
                    display: flex;
                    margin-left: 20px;
                    border: 2px solid #c4c1c1;

                    li {
                        width: 145px;
                        height: 35px;
                        text-align: center;
                        line-height: 35px;
                        border-right: 2px solid #c4c1c1;
                    }
                    li:last-child {
                        border-color: transparent;
                    }
                }
            }
            .quantity {
                > p {
                    float: left;
                }
                .quantityInput {
                    float: left;

                    margin-left: 47px;
                    ul {
                        display: flex;
                        li:first-child {
                            input {
                                width: 72px;
                                height: 35px;
                                border: 2px solid #c4c1c1;
                                text-align: center;
                                outline: none;
                            }
                            input::-webkit-outer-spin-button,
                            input::-webkit-inner-spin-button {
                                -webkit-appearance: none;
                            }
                            input[type="number"] {
                                -moz-appearance: textfield;
                            }
                        }
                        li:last-child {
                            margin-left: 10px;
                            .top {
                                margin-bottom: 5px;
                            }
                            .disable {
                                cursor: not-allowed !important;
                            }
                            .top,
                            .bottom {
                                text-align: center;
                                width: 22px;
                                height: 15px;
                                border: 1px solid #c4c1c1;
                                line-height: 15px;
                                font-size: 16px;
                                -moz-user-select: none; /*火狐*/
                                -webkit-user-select: none; /*webkit浏览器*/
                                -ms-user-select: none; /*IE10*/
                                -khtml-user-select: none; /*早期浏览器*/
                                user-select: none;
                                color: #ccc;
                                &:hover {
                                    cursor: pointer;
                                    border-color: #ff8800;
                                }
                                &:hover .iconfont {
                                    color: #ff8800;
                                }
                            }
                        }
                    }
                }
            }
        }
        .deliveryOptions {
            width: 582px;
            margin: 30px 0 0 30px;
            .options {
                p {
                    margin-top: 5px;
                }
                p,
                div {
                    float: left;
                }
                div {
                    margin-left: 6px;
                }
            }
        }
        .specifications .specifica .addrCascader {
            height: 35px;
            line-height: 35px;
            /deep/ .ivu-input {
                font-size: 16px;
                background: transparent;
                color: #333;
                outline: none;
                height: 35px;
                border-color: transparent;
                padding-bottom: 7px;
                &:hover {
                    border-color: transparent;
                }
            }
            /deep/ .ivu-input:focus {
                border-color: transparent;
                outline: transparent;
                box-shadow: 0 0 0 0px rgba(0, 0, 0, 0.1);
            }
            /deep/ .ivu-date-picker-focused input {
                border-color: transparent;
                outline: transparent;
                box-shadow: 0 0 0 0px rgba(0, 0, 0, 0.1);
            }
        }
        .textInput {
            width: 582px;
            margin: 30px 0 0 30px;
            .addrad {
                p {
                    margin-top: 5px;
                }
                p,
                div {
                    float: left;
                }
                div {
                    margin-left: 20px;
                    input {
                        width: 224px;
                        height: 35px;
                        line-height: 35px;
                        outline: none;
                        border: 2px solid #c4c1c1;
                        padding-left: 10px;
                    }
                }
            }
        }
        .specifications .specifica .totalFee {
            color: #ff8800;
            font-size: 18px;
            font-weight: bold;
            border-color: transparent;
            margin-left: 10px;
        }
    }
}
.descImage {
    margin-top: 30px;
    .detail {
        margin-top: 30px;
    }
}
</style>